'use client';
import { useEffect } from 'react';
import { useCurrentInvestor, useDispatch } from '@/hooks/useStore';
import { setInvestorCompanies as dispatchSetInvestorCompanies } from '@/store/slices/companyInvestorsSlice';
import { setFinancialReports as dispatchSetFinancialReports } from '@/store/slices/financialReportsSlice';
import { useAppState } from '@/hooks/useAppState';
import { usePagination } from '@/hooks/usePagination';
import { useToggle } from '@/hooks/useToggle';
import WelcomeCard from '@/components/WelcomeCard';
import InsightsCards from '@/components/InsightsCards';
import InvestorCompaniesCard from '@/components/InvestorCompaniesCard';
import { classes, fetchInvestorData } from './utils';

export default function HomePage() {
  const dispatch = useDispatch();
  const investor = useCurrentInvestor();
  const { onApiError } = useAppState();
  const [pagination, setPagination] = usePagination(1, 50);
  const [isFetchingData, toggleFetchingData] = useToggle(false);

  useEffect(() => {
    if (investor) fetchData();
  }, [investor]);

  const fetchData = async () => {
    try {
      toggleFetchingData(true);
      const data = await fetchInvestorData(investor!.id);
      dispatch(dispatchSetInvestorCompanies(data.investorCompanies));
      dispatch(dispatchSetFinancialReports(data.financialReports));
      setPagination(data.pagination);
      toggleFetchingData(false);
    } catch (err) {
      toggleFetchingData(false);
      onApiError(err, 'Error fetching investments', () => fetchData());
    }
  };

  return (
    <div className={classes.wrapper}>
      <WelcomeCard />
      {investor && <InsightsCards investorId={investor.id} />}
      {investor && (
        <InvestorCompaniesCard
          isFetchingData={isFetchingData}
          investorId={investor.id}
        />
      )}
    </div>
  );
}
